/*
 *  Copyright IBM Corp. 2025
 *
 *  This source code is licensed under the Apache-2.0 license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  @license
 */

/* eslint-disable prefer-destructuring */

const NODE_ENV = process.env.NODE_ENV;
const VERSION = process.env.VERSION;

export { NODE_ENV, VERSION };
